export default [
    {
        name: "EducationType_Bachelor",
        value: "Bachelor"
    },
    {
        name: "EducationType_Master",
        value: "Master"
    },
    {
        name: "EducationType_PreMaster",
        value: "PreMaster"
    },
    {
        name: "EducationType_Exchange",
        value: "Exchange"
    },
    {
        name: "EducationType_PostGraduate",
        value: "PostGraduate"
    },
    {
        name: "EducationType_Bijvak",
        value: "AdditionalModule"
    },
    {
        name: "EducationType_SemesterAmsterdam",
        value: "SemesterAmsterdam"
    },
    {
        name: "EducationType_Contract",
        value: "Contract"
    }
]